function initYandexSmartCaptcha() {
    const container = document.getElementById('yandex-smart-captcha-container');

    if (!container || !window.smartCaptcha) {
        return;
    }

    const form = container.closest('form');
    const tokenInput = form?.querySelector('input[name="yandex-smart-captcha-token"]');

    if (!form) {
        return;
    }

    let isSubmitting = false;

    const widgetId = window.smartCaptcha.render(
        container.id,
        {
            sitekey: container.dataset.sitekey,
            hl: container.dataset.hl,
            invisible: true,
            callback(token) {
                if (tokenInput) {
                    tokenInput.value = token;
                }

                isSubmitting = true;
                form.submit();
            },
        }
    );

    form.addEventListener('submit', (event) => {
        if (isSubmitting) {
            return;
        }

        event.preventDefault();

        if (tokenInput) {
            tokenInput.value = '';
        }

        window.smartCaptcha.execute(widgetId);
    });
}


window.initYandexSmartCaptcha = initYandexSmartCaptcha;

const script = document.createElement('script');
script.src = 'https://smartcaptcha.cloud.yandex.ru/captcha.js?render=onload&onload=initYandexSmartCaptcha';
document.head.appendChild(script);
